import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {go} from '@ngrx/router-store';

// Services
import {AppService} from './app-service';

// Interfaces
import {AppState} from '../state/interfaces/app-state';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:NavigationService'));

@Injectable()
export class NavigationService {
    
    constructor(
        private _store: Store<AppState>,
        private _appService: AppService,
        private _router: Router
    ) {
        // 'Construct navigation service' );
    }

    public state:any = {
        currentPage: 'catalog'
    }

    public openSummaryPage () {
        // 'Open summary page' );

        // @ngrx/router-store is broken because of webpack
        //this._store.dispatch( go(['/summary']) );

        this._router.navigate(['/summary']);
        this.state.currentPage = 'summary';
    }

    
    public openCatalogPage () {
        // 'Open catalog page' );

        // @ngrx/router-store is broken because of webpack
        //this._store.dispatch( go(['/catalog']) );

        this._router.navigate(['/catalog']);
        this.state.currentPage = 'catalog';
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/services/navigation-service.ts